import ImageIcon from '@mui/icons-material/Image';
import { CircularProgress, Grid } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';
import { EmployeeModel } from 'domains/models/EmployeeModel';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRootStore } from 'store/StoreContextProvider';
import AdvicePageStore from './store/AdvicePageStore';

import Grid2 from '@mui/material/Unstable_Grid2';
import BasicImage from 'pages/MyPage/component/BasicImage';
import starIcon from '../../assets/image/starIcon.png';

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  // "@keyframes ripple": {
  //   "0%": {
  //     transform: "scale(.8)",
  //     opacity: 1,
  //   },
  //   "100%": {
  //     transform: "scale(2.4)",
  //     opacity: 0,
  //   },
  // },
}));

const UnStyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: '#b7b7b7',
    color: '#b7b7b7',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: 'ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  // "@keyframes ripple": {
  //   "0%": {
  //     transform: "scale(.8)",
  //     opacity: 1,
  //   },
  //   "100%": {
  //     transform: "scale(2.4)",
  //     opacity: 0,
  //   },
  // },
}));

interface Props {
  pageStore: AdvicePageStore;
}
function AdvicePageListView(props: Props) {
  const { pageStore } = props;
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  const { headerStore } = useRootStore();

  React.useEffect(() => {
    headerStore.setPageTitle('Summary');
    headerStore.setPageSubTitle(' 내가 평가한 대상들의 요약을 확인할 수 있습니다.');
    //console.log(pageStore.employeeList);
  }, []);

  const handleClickTarget = (target: any) => {
    console.log(target);
    pageStore.setIsOpenModal(true);
  };

  const handleClickEmployee = (employee: EmployeeModel) => {
    navigate('/advice-timeline', { state: { employee: toJS(employee) } });
  };

  const handleClickMoredata = () => {
    console.log('더보기');
  };

  return pageStore.isLoading ? (
    <Grid container justifyContent={'center'} style={{ marginTop: '200px' }}>
      <CircularProgress />
    </Grid>
  ) : (
    <Grid2 container spacing={2}>
      {pageStore.employeeList?.map((employee) => {
        return (
          <Grid2 xs={12} sm={12} md={4} key={employee.id}>
            <ListItem
              key={employee?.names?.fullname}
              style={{
                border: '1px solid #006DCE55',
                borderRadius: '15px',
                marginBottom: '14px',
                padding: '18px',
              }}
              secondaryAction={
                <Grid container alignItems={'center'}>
                  <Grid style={{ marginTop: '4px' }}>
                    <img src={starIcon} alt='starIcon' />
                  </Grid>
                  <Grid style={{ marginLeft: '6px' }}>{employee.userData?.avg ? employee.userData?.avg.toFixed(2) : 0}</Grid>
                </Grid>
              }
            >
              {employee.child?.userData.todoCount === 0 ? (
                <UnStyledBadge overlap='circular' anchorOrigin={{ vertical: 'top', horizontal: 'right' }} variant='dot'>
                  {employee.userData?.profile ? (
                    <BasicImage
                      src={employee.userData?.profile}
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        overflow: 'hidden',
                      }}
                    />
                  ) : (
                    <Avatar>
                      <ImageIcon
                        sx={{
                          borderRadius: '50%',
                          objectFit: 'cover',
                          overflow: 'hidden',
                        }}
                      />
                    </Avatar>
                  )}
                </UnStyledBadge>
              ) : (
                <StyledBadge overlap='circular' anchorOrigin={{ vertical: 'top', horizontal: 'right' }} variant='dot'>
                  {employee.userData?.profile ? (
                    <BasicImage
                      src={employee.userData?.profile}
                      style={{
                        width: 44,
                        height: 44,
                        borderRadius: '50%',
                        objectFit: 'cover',
                        overflow: 'hidden',
                      }}
                    />
                  ) : (
                    <Avatar>
                      <ImageIcon
                        sx={{
                          borderRadius: '50%',
                          objectFit: 'cover',
                          overflow: 'hidden',
                        }}
                      />
                    </Avatar>
                  )}
                </StyledBadge>
              )}

              <ListItemText
                primary={
                  <span
                    style={{
                      fontFamily: 'Pretendard',
                      fontStyle: 'normal',
                      fontWeight: 600,
                      fontSize: '16px',
                      lineHeight: '16px',
                      color: '#000000',
                      opacity: employee.child?.userData.todoCount === 0 ? '0.3' : '1',
                    }}
                  >
                    {employee.userData.deptName}
                  </span>
                }
                secondary={
                  <span
                    style={{
                      fontFamily: 'Pretendard',
                      fontStyle: 'normal',
                      fontWeight: 500,
                      fontSize: '14px',
                      lineHeight: '14px',
                      color: '#212121',
                      opacity: employee.child?.userData.todoCount === 0 ? '0.3' : '1',
                    }}
                  >
                    {employee?.names?.fullname}
                    <span
                      style={{
                        fontWeight: 400,
                        fontSize: '12px',
                        lineHeight: '12px',
                        color: '#6C6B6F',
                        marginLeft: '5px',
                        opacity: employee.child?.userData.todoCount === 0 ? '0.3' : '1',
                      }}
                    >
                      {employee.userData.jobTitle}
                    </span>
                  </span>
                }
                onClick={(e) => handleClickEmployee(employee)}
                style={{
                  margin: 0,
                  cursor: 'pointer',
                  marginLeft: '16px',
                }}
              />

              {/* <Button variant='contained' onClick={() => handleClickTarget(employee)}></Button> */}
            </ListItem>
          </Grid2>
        );
      })}
      {/* <Button onClick={handleClickMoredata}>+더보기</Button> */}
    </Grid2>
  );

  // return (
  //   <List sx={{ width: "100%", bgcolor: "background.paper" }}>
  //     {pageStore.employeeList.map((employee) => {
  //       return (
  //         <ListItem
  //           key={employee?.names?.fullname}
  //           style={{
  //             border: "1px solid black",
  //             borderRadius: "10px",
  //             marginBottom: "10px",
  //           }}
  //           onClick={() => handleClickEmployee(employee)}
  //         >
  //           <ListItemAvatar>
  //             <Avatar>
  //               <ImageIcon />
  //             </Avatar>
  //           </ListItemAvatar>
  //           <ListItemText
  //             primary={employee.names?.fullname}
  //             secondary={`${employee.userData?.jobTitle}, ${employee.userData?.deptName}`}
  //           />

  //           <div
  //             style={{
  //               marginRight: "20px",
  //             }}
  //           >
  //             {employee.userData?.avg}점
  //           </div>
  //         </ListItem>
  //       );
  //     })}
  //   </List>
  // );
}

export default observer(AdvicePageListView);
